import type { LibItemSysIcon, TemplateId } from '@types';

type Group = {
  name: string;
  templateType?: TemplateId;
  list: LibItemSysIcon[];
  size: number;
};

export const cbIconList: Group[] = [
  {
    name: '经典1.0',
    size: 38,
    list: [
      { url: '/imgs/link.3e52a3441e9090c7c7a73994560ebbf7.png', frame: 1 },
      { url: '/imgs/group.2ac3cc956d271fe2f85b32ef735894c2.png', frame: 1 },
      { url: '/imgs/mp.2ab7a26dc9d25cb0a82934bc331f8091.png', frame: 1 },
      { url: '/imgs/image.d3b969b2633d03e32c36ae6dbbf93fb3.png', frame: 1 },
      { url: '/imgs/live.fce86646e1f144bd76b25bb108e58371.png', frame: 1 },
      { url: '/imgs/tel.c0ba9a0292239c47381b4110ae6cf1f9.png', frame: 1 },
      { url: '/imgs/nav.e76a8c4e552a8849c27c37b18f994c87.png', frame: 1 },
      { url: '/imgs/text.31ce14651255c52ad6588436b3707ad7.png', frame: 1 },
      { url: '/imgs/arctile.d0747991d0fd679015cfe41743e07ae3.png', frame: 1 },
      { url: '/imgs/music.d7794d3593178921838855651b664f82.png', frame: 1 },
      { url: '/imgs/video.e7e372ba867d923a24a77025c40e8e62.png', frame: 1 },
      { url: '/imgs/3d.5e52336cf1744d6cdbe9e8c380ccaf61.png', frame: 1 },
      { url: '/imgs/list.1405ce71491e460ad4e5b452de7bf56e.png', frame: 1 },
      { url: '/imgs/prev.6eebdeee2465e6501102cbb44e6fbe80.png', frame: 1 },
      { url: '/imgs/next.409487de1b3eb7a778db90f8ac03f5b5.png', frame: 1 },
      { url: '/imgs/cutom.c03679f49f5637118a29f6643c006a4d.png', frame: 1 },
      { url: '/imgs/wx.f49427f4789652678d97eb1c2727fd30.png', frame: 1 },
      { url: '/imgs/act.f539ab8beba2d4f0a558413f41fb8101.png', frame: 1 },
      { url: '/imgs/xc.1daed63eba8f065100c15cfb2ce423ec.png', frame: 1 },
      { url: '/imgs/mt.f13199ca25bad37a18c14af036987354.png', frame: 1 },
      { url: '/imgs/tb.b5076eb7b3df828ed25acf3d6ce56c32.png', frame: 1 },
      { url: '/imgs/jd.7316143d4e627a789d437b27d5ba0fe4.png', frame: 1 },
      { url: '/imgs/qr.ec360be583ef6924a474334fef2211ee.png', frame: 1 },
      { url: '/imgs/index.f06f4b7b2556f54491c22143f4663f12.png', frame: 1 },
      { url: '/imgs/pdf_1.63960f951fbba843b37e266d06518c37.png', frame: 1 },
      { url: '/imgs/m3d_1.9d4abb3fc0de318822e0a80f689bb9ac.png', frame: 1 },
    ],
  },
  {
    name: '经典2.0',
    size: 40,
    list: [
      { url: '/imgs/cb01.b897aa719bde224c2049c411ebc4a14e.png', frame: 1 },
      { url: '/imgs/cb02.87f551e773f56b99f15d494f3a0ce1be.png', frame: 1 },
      { url: '/imgs/cb03.4747aaba4801849b600aa2734d3fdf6f.png', frame: 1 },
      { url: '/imgs/cb04.ccaf0b1534fcd60c293a724c2f0111a6.png', frame: 1 },
      { url: '/imgs/cb05.7f26244d7c254aa6f72362ef57a5ba22.png', frame: 1 },
      { url: '/imgs/cb06.db981e58ad4204275867b2c146151f85.png', frame: 1 },
      { url: '/imgs/cb07.87bc22dcca6d7f377e9a1ac1fc25cfd8.png', frame: 1 },
      { url: '/imgs/cb08.87cf04e2b32bc4d1318ca0067f205cc4.png', frame: 1 },
      { url: '/imgs/cb09.494597f3f74c5ad0e149f43edf98e9c3.png', frame: 1 },
      { url: '/imgs/cb10.aaf58d6450c115c911197557e5cd4f7d.png', frame: 1 },
      { url: '/imgs/cb11.48859edaed5c22df56b3da1312c08a0a.png', frame: 1 },
      { url: '/imgs/cb12.4ec49da08cb1cbd595499cdf78d4e98e.png', frame: 1 },
      { url: '/imgs/cb13.58fb1f06f31bbaf2eb083e77d120eaf5.png', frame: 1 },
      { url: '/imgs/prev.210693fd89fedc0a0783fbe79a7b1092.png', frame: 1 },
      { url: '/imgs/next.39e3e6c1da5653bb8acb4c1b89fa23e5.png', frame: 1 },
      { url: '/imgs/cb14.b34414cb48034e2d88e9330c200962d3.png', frame: 1 },
      { url: '/imgs/cb15.81e5e1e7d389e385476df271dfda0048.png', frame: 1 },
      { url: '/imgs/cb16.169015f93a4302c23188f86673cf5998.png', frame: 1 },
      { url: '/imgs/cb17.7a93bda76c3b47e2a2e6a4abb15d4338.png', frame: 1 },
      { url: '/imgs/cb18.ccc94edd0d2c9a3d9575b846a6cb9964.png', frame: 1 },
      { url: '/imgs/cb19.d0cd9b880898d3d3b660088096647878.png', frame: 1 },
      { url: '/imgs/cb20.2774d5f2555dbd647abeb0c85f7b4a95.png', frame: 1 },
      { url: '/imgs/pdf_2.5206c704c1ca3923849d05a3cb2294b0.png', frame: 1 },
      { url: '/imgs/remark.9eea3e8b2e8f15a8402085c0a12e3bda.png', frame: 1 },
      { url: '/imgs/share.0cfb73073e6373caf5832e968f0734d2.png', frame: 1 },
      { url: '/imgs/like.a062dd954f8a772a798d4c53d676c9fe.png', frame: 1 },
      { url: '/imgs/like-a.3dbf5e9179d913b0e2347d4634b49c7a.png', frame: 1 },
      { url: '/imgs/comment.11cf0c7b2bc225875a2ed4a96004937b.png', frame: 1 },
      { url: '/imgs/m3d.d93b9dd7b8bdceb50ec9c50747c4d610.png', frame: 1 },
      { url: '/imgs/music.9eb102cd0783cd21bd428be4e6dd17cf.png', frame: 1 },
      { url: '/imgs/3d.accebaca77e95ddb157a27914ba5a692.png', frame: 1 },
      { url: '/imgs/action.11a43d1a499f5dffe5e2f135fd20b59d.png', frame: 1 },
      { url: '/imgs/article.501722411ccb9141c4b30c719868a600.png', frame: 1 },
      {
        url: '/imgs/comment-off.cf4b91b02c64e3a47834c99eca353089.png',
        frame: 1,
      },
      { url: '/imgs/comment.1ea2aa3e6c6f6af6fafd4b2994afc5b2.png', frame: 1 },
      { url: '/imgs/desc.69acc7e63415be84edfe2f211a3ea6f0.png', frame: 1 },
      { url: '/imgs/event.dfa5d26d797394d32d7a7683a2208cc6.png', frame: 1 },
      { url: '/imgs/group.d69803afb70056ad9899a0cff53a8034.png', frame: 1 },
      { url: '/imgs/home.593765b81db376ab4b6421d98742600e.png', frame: 1 },
      { url: '/imgs/image.2bb5d0dac9e8d49d43d9a58de370cefc.png', frame: 1 },
      { url: '/imgs/jd.3db0a08df224a4434a5d72ab07d26e8a.png', frame: 1 },
      { url: '/imgs/like-a.2b61a1ec3293518881c998a1f23dec02.png', frame: 1 },
      { url: '/imgs/like.22e737a79b1a07b05a8cdb49a23a793e.png', frame: 1 },
      { url: '/imgs/link.4ae79f9b4cfd23925d367982543c024c.png', frame: 1 },
      { url: '/imgs/list.3b2a631c00a3084d51d9f726eacbef1d.png', frame: 1 },
      { url: '/imgs/prevbl.357f181aab9ee01718b1858693c44d84.png', frame: 1 },
      { url: '/imgs/nextbl.cc2762f6bd6eae3f7ee8b1cdc0388fc7.png', frame: 1 },
      { url: '/imgs/live.a1d9c0509b88a4aada93f4cfea0c863a.png', frame: 1 },
      { url: '/imgs/mp.9300098e2a1c55df2911096e86e63647.png', frame: 1 },
      { url: '/imgs/mt.3a3a72fff93736e413b52e21f405a5b0.png', frame: 1 },
      { url: '/imgs/nav.e3b91c61ddbdf63a35d32bd7a4045617.png', frame: 1 },
      { url: '/imgs/qr.8328411e87fc88201809c77c705d8611.png', frame: 1 },
      { url: '/imgs/share.d38925989a4543753adacd94d91074d1.png', frame: 1 },
      { url: '/imgs/tb.9de6bb87122955c734eeef3ab9a9c407.png', frame: 1 },
      { url: '/imgs/tel.b85a260010117d67d4c1da3b3e6a75c1.png', frame: 1 },
      { url: '/imgs/txt.59fa32d8364b321e98cfab540823d4fb.png', frame: 1 },
      { url: '/imgs/video.5afa7cca07aa118eb287e769f0ab4067.png', frame: 1 },
      { url: '/imgs/wechat.d7fa2c25ce7af142fb6f3f6fbf1b836e.png', frame: 1 },
      { url: '/imgs/xc.c870ab33142ab1c579e0d91fedb6d5ec.png', frame: 1 },
      {
        url: '/imgs/pdf_2_pure.dab8a4b901311ea164c516a4a600686b.png',
        frame: 1,
      },
      { url: '/imgs/m3d_l.7525a028674efe21a6140946ee006875.png', frame: 1 },
    ],
  },
  {
    name: '清爽简洁',
    size: 24,
    list: [
      { url: '/imgs/3d.cd8ca96f5de4ac630f4293c8aa956246.png', frame: 1 },
      { url: '/imgs/action.5cb1e197d6b6caab67040e4f694c2790.png', frame: 1 },
      { url: '/imgs/active.27bc04aaad4c43a5a656cc4dea36d222.png', frame: 1 },
      { url: '/imgs/article.9e939ee63bc823a3d0f2982d1d54b7d2.png', frame: 1 },
      {
        url: '/imgs/comment-off.300d20dc43cd222613568cd37e3a185a.png',
        frame: 1,
      },
      { url: '/imgs/comment.0a302552185078b38a88d02eee9f3900.png', frame: 1 },
      { url: '/imgs/desc.4337b4f6d8f08a613afce6b80d857278.png', frame: 1 },
      { url: '/imgs/group.134328dd3460fa7a38f924febd1eecaf.png', frame: 1 },
      { url: '/imgs/home.8c9a616f7b4101c17ab745fce86e7c57.png', frame: 1 },
      { url: '/imgs/image.a680921c261f1a2a7a9eac1fd42611d4.png', frame: 1 },
      { url: '/imgs/jd.9a8c88c6080c0ccf05f22802a5a11f8c.png', frame: 1 },
      { url: '/imgs/like.af03efe60d5d94de2cbd59e9baef53a3.png', frame: 1 },
      { url: '/imgs/liked.7255cf1e18b128db28b980afd5734134.png', frame: 1 },
      { url: '/imgs/link.f6ecfd407a8e8c6d8161346f8cf666c9.png', frame: 1 },
      { url: '/imgs/list.07783afd9139350ac463ec7a9c8e4d3d.png', frame: 1 },
      { url: '/imgs/prev.95011328947cce65a36c0afd003ed5d6.png', frame: 1 },
      { url: '/imgs/next.2164e7691ac6d80a322b344065db478a.png', frame: 1 },
      { url: '/imgs/live.f00aedfbdd142e83bd0fa0d8d56b177a.png', frame: 1 },
      { url: '/imgs/mp.7a415ed3ccc6a7677068aea399a17d47.png', frame: 1 },
      { url: '/imgs/mt.46d02cb53d9aa0a6079699108c031a7e.png', frame: 1 },
      { url: '/imgs/music.53d3572cf5ae924f62522ccbd6600b12.png', frame: 1 },
      { url: '/imgs/nav.a2684eac2820b2fb7a1f511bab8a7934.png', frame: 1 },
      { url: '/imgs/qr.4cfed890fecb641d7c005c145e7c0bbe.png', frame: 1 },
      { url: '/imgs/share.b7b5159a4ca0fc761c3299524d804a3e.png', frame: 1 },
      { url: '/imgs/tb.fb946d82dab6a0587d0ebf6286e45ed0.png', frame: 1 },
      { url: '/imgs/tel.76fd1086ae5cfbc3a08761584da57707.png', frame: 1 },
      { url: '/imgs/txt.d003316b5a1d74c2e84f6cd3e9512505.png', frame: 1 },
      { url: '/imgs/video.bd84d065984314aaa96a401dc4114eea.png', frame: 1 },
      { url: '/imgs/wechat.8037c6ed5906f45afd6317008039df2d.png', frame: 1 },
      { url: '/imgs/xc.7bcee7e203ee3864684c64e74413ba31.png', frame: 1 },
      { url: '/imgs/pdf_pure.b7e88ad635fa697ff33bc5694986a9f0.png', frame: 1 },
      { url: '/imgs/m3d_s.f756d7124dc79821359a96b1dc6a082d.png', frame: 1 },
    ],
  },
  {
    name: '房产版B',
    size: 16,
    list: [
      { url: '/imgs/cb01.a9d46400577645adbac8f5df06212899.png', frame: 1 },
      { url: '/imgs/cb02.e57ab36d0e79425684dbf86f126b258c.png', frame: 1 },
      { url: '/imgs/cb03.3fbc2cd702ca2c9410155bf167836ad1.png', frame: 1 },
      { url: '/imgs/cb04.8e0f26bfa753c06971660712ead015e5.png', frame: 1 },
      { url: '/imgs/cb05.e45e67dd15df59cc98655e3730db86df.png', frame: 1 },
      { url: '/imgs/cb06.f4eea2e37d992425b5e69b3dd2180410.png', frame: 1 },
      { url: '/imgs/cb07.64728c8dae87c3c1a9b3ca5f708e2e44.png', frame: 1 },
      { url: '/imgs/cb08.baf6c7c78c5de0678e714f7c7a72612a.png', frame: 1 },
      { url: '/imgs/cb09.6c2b794ea3ebb1ecfccdd89cbfc3f1c8.png', frame: 1 },
      { url: '/imgs/cb10.85e4aa09a096d4588c925baea12ad84e.png', frame: 1 },
      { url: '/imgs/cb11.721a1ef46910f1621f9ebeff476ee0d1.png', frame: 1 },
      { url: '/imgs/cb12.834b1aa2966484a4d1c86e3898e0b273.png', frame: 1 },
      { url: '/imgs/cb13.6f99f0df9fb710cff5b9a7efd15d9d17.png', frame: 1 },
      { url: '/imgs/prev.1a36c3b3b6f2bc8571f3c2162ac1de94.png', frame: 1 },
      { url: '/imgs/next.e3d5c65c50c407c25cefa5bd3ff9a35f.png', frame: 1 },
      { url: '/imgs/cb14.b885fd71eb464545e324f69af0f8e0d8.png', frame: 1 },
      { url: '/imgs/cb15.1af3115b0e42c971c2c737f57c9c740b.png', frame: 1 },
      { url: '/imgs/cb16.247dac8a70be82579ab1944dd64c6bad.png', frame: 1 },
      { url: '/imgs/cb17.a87abdae3d189415076b65871e6cadfe.png', frame: 1 },
      { url: '/imgs/cb18.b946af53564458956dc6d2a669257bec.png', frame: 1 },
      { url: '/imgs/cb19.9d6fdb5e443f65428991cec8f4d3e021.png', frame: 1 },
      { url: '/imgs/cb20.47e0b971cbfa7b8993e975359d72e222.png', frame: 1 },
      { url: '/imgs/pdf_fcb.7d406384e8dcd333835ea52d41bd9067.png', frame: 1 },
      { url: '/imgs/m3d_r.c91909a12b8611f8503f69cfdb7a99f6.png', frame: 1 },
    ],
  },
  {
    name: '元宇宙模板',
    size: 30,
    list: [
      { url: '/imgs/cb01.345370b1ad4962a9447754445d66c997.png', frame: 1 },
      { url: '/imgs/cb02.4af0f1c5f54c811d0eb411d57d55307b.png', frame: 1 },
      { url: '/imgs/cb03.d4bfb6b4ba9a5e9a6d2fdb4de9245153.png', frame: 1 },
      { url: '/imgs/cb04.09168d68d4ad2ee01678337dd471b61b.png', frame: 1 },
      { url: '/imgs/cb05.1c240f1bfb3ed54454462a9e22bb3ab8.png', frame: 1 },
      { url: '/imgs/cb06.e0f0ca17a586de7b2261dae0b10f7fe6.png', frame: 1 },
      { url: '/imgs/cb07.965c29705e81dfe448a9df28341fced9.png', frame: 1 },
      { url: '/imgs/cb08.984430fe4d5725e8fe9619d28866e366.png', frame: 1 },
      { url: '/imgs/cb09.7b95ba844689a80769111cc9c07cceda.png', frame: 1 },
      { url: '/imgs/cb10.f6a1dcb35430169d8c9f1bc7c36627ba.png', frame: 1 },
      { url: '/imgs/prev.3ff2ec4dcf1fa6e7a0445541ef510638.png', frame: 1 },
      { url: '/imgs/next.d2840612b778f1d90a43b0d31a62031b.png', frame: 1 },
      { url: '/imgs/cb11.0408fa143639d03acad94b745ca34d8f.png', frame: 1 },
      { url: '/imgs/cb12.06428fd1a094aa16fc8bfdeacd067a0c.png', frame: 1 },
      { url: '/imgs/cb13.a45580f30e829cb2f68e5fd6e4f24008.png', frame: 1 },
      { url: '/imgs/cb14.a4eb6e6767a065ba204abe16c8976f32.png', frame: 1 },
      { url: '/imgs/cb15.dc072efc1a7a7488a03fae1d901fbc2e.png', frame: 1 },
      { url: '/imgs/cb16.a88d59d538142f7f614aded13dd933a2.png', frame: 1 },
      { url: '/imgs/cb17.abb79af69663b9c572b874ccffce886f.png', frame: 1 },
      { url: '/imgs/cb18.0e9d131c985de525af8e78cc5ca52dc5.png', frame: 1 },
      { url: '/imgs/cb19.f61c541054d9cc5d96cf03804c1550c2.png', frame: 1 },
      { url: '/imgs/cb20.e0b74d5e52690b6fd297321c8e606e7c.png', frame: 1 },
      { url: '/imgs/pdf_meta.9217a84147a105eee334aef705b9ed7b.png', frame: 1 },
      { url: '/imgs/m3d_m.c3f34a07688d2426618966770ac339ea.png', frame: 1 },
    ],
  },
];
